import { DocumentNode, gql } from '@apollo/client'

export const LINK_API_CLIENT_TO_DAYCARE: DocumentNode = gql`
    mutation LinkApiClientToDaycare($id: Int!, $daycareId: Int!) {
        linkApiClientToDaycare(id: $id, daycareId: $daycareId)
    }
`

export const UNLINK_API_CLIENT_FROM_DAYCARE: DocumentNode = gql`
    mutation UnlinkApiClientFromDaycare($id: Int!, $daycareId: Int!) {
        unlinkApiClientFromDaycare(id: $id, daycareId: $daycareId)
    }
`

export const REVOKE_ALL_API_CLIENT_TOKENS: DocumentNode = gql`
    mutation RevokeAllApiClientTokens($id: Int!) {
        revokeAllApiClientTokens(id: $id)
    }
`
